import React from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Table, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";
import PanelHeader from "components/panelheader/panelHeader";
import PaginationControls from "components/paginationcontrols/paginationControls";
import { usePageLoading } from "hooks/usePageLoading";
import { getTorneos, deleteTorneo } from "services/torneosService";
import { getConfig } from "config/config";
import { toastBigError, toastConfirm } from "components/utils/toasts";
import { cleanString } from "components/utils/cleanString";
import { paginate } from "components/utils/paginate";
import _ from "lodash";

const Torneos = (props) => {
  const doneLoading = usePageLoading(props);
  const [allRecords, setAllRecords] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [sortColumn, setSortColumn] = React.useState({ path: "nombre", order: "asc" });
  const [searchQuery, setSearchQuery] = React.useState("");
  const config = getConfig();
  const pageSize = config.recordsPerPage;
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const records = await getTorneos();
      if (records === "NETWORK ERROR") toastBigError("Error", "Error de Conexión");
      else setAllRecords(records);
    } catch {
    } finally {
      doneLoading();
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const getPagedData = () => {
    let filtered = [];
    if (searchQuery.trim().length > 0) {
      filtered = allRecords.filter((m) => cleanString(m.descripcion).includes(cleanString(searchQuery)));
    } else {
      filtered = allRecords;
    }
    const ordered = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const records = paginate(ordered, currentPage, pageSize);
    return { totalCount: filtered.length, records };
  };

  const { totalCount, records } = getPagedData();
  if (currentPage > Math.ceil(totalCount / pageSize) && totalCount > 0) setCurrentPage(Math.ceil(totalCount / pageSize));

  const labelPages = Math.ceil(totalCount / pageSize) > 1 ? currentPage + "/" + Math.ceil(totalCount / pageSize) : "";

  const thead = [
    { header: "Nombre", width: "80%" },
    { header: "Año", width: "10%" },
    { header: "", width: "5%" },
    { header: "", width: "5%" },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.currentTarget.value);
  };

  const handleNew = () => {
    navigate("/admin/torneos/nuevo", {
      state: { action: "A" },
    });
  };

  const handleView = (id) => {
    navigate("/admin/torneos/" + id, {
      state: { action: "C" },
    });
  };

  const handleEdit = (id) => {
    // history.push({
    //   pathname: "/salas/" + id,
    //   state: { action: "E" },
    // });
    navigate("/admin/torneos/" + id, {
      state: { action: "E" },
    });
  };

  const handleDelete = async (id) => {
    // event.preventDefault();
    toastConfirm("¿ Eliminar torneo ?", "Se eliminarán todos los partidos y resultados", () => doDelete(id));
  };

  const doDelete = async (id) => {
    const originalRecords = allRecords;
    const records = allRecords.filter((m) => m._id !== id);
    setAllRecords(records);
    try {
      await deleteTorneo(id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) toastBigError("Ese registro ya fue eliminado");
      setAllRecords(originalRecords);
    }
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row className="align-items-center">
                  <Col>
                    <Button className="pull-right btn-arhock" onClick={() => handleNew()}>
                      Nuevo Torneo
                    </Button>
                  </Col>
                </Row>
                <Table responsive hover>
                  <thead className="text-black">
                    <tr>
                      {thead.map((prop, key) => {
                        if (key === thead.length - 2)
                          return (
                            <th key={key} className="text-left" style={prop.width ? { width: `${prop.width}` } : ""}>
                              {prop.header}
                            </th>
                          );
                        return (
                          <th key={key} color="black" style={prop.width ? { width: `${prop.width}` } : ""}>
                            {prop.header}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item) => (
                      <tr key={Math.random()}>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.nombre}</span>
                        </td>
                        <td className="clickable" onClick={() => handleView(item._id)}>
                          <span className="black">{item.ano}</span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleEdit(item._id)}>
                            <div className="icon icon-success">
                              <i className="fa fa-pencil-square-o" color="success" />
                            </div>
                          </span>
                        </td>
                        <td>
                          <span className="clickable" onClick={() => handleDelete(item._id)}>
                            <div className="icon icon-danger">
                              <i className="fas fa-trash-alt" color="danger" />
                            </div>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Row className="pull-right">
                  <PaginationControls onPageChange={(page) => handlePageChange(page)} itemsCount={totalCount} pageSize={pageSize} currentPage={currentPage} />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Torneos;
